import { render } from "./AddMaterial.vue?vue&type=template&id=48ea65d2&scoped=true"
import script from "./AddMaterial.vue?vue&type=script&lang=js"
export * from "./AddMaterial.vue?vue&type=script&lang=js"

import "./AddMaterial.vue?vue&type=style&index=0&id=48ea65d2&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ea65d2"]])

export default __exports__